/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../../../../Fixes';
import Builder from '../../../../../../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "model": {
                    "nested": {
                      "settings": {
                        "nested": {
                          "rst": {
                            "nested": {
                              "common": {
                                "nested": {
                                  "Seating": {
                                    "fields": {
                                      "isEnabled": {
                                        "type": "bool",
                                        "id": 1,
                                        "rule": "optional",
                                        "options": {
                                          "default": false
                                        }
                                      },
                                      "seatAssignmentOption": {
                                        "type": ".squareup.devicesettings.profiles.v2.model.settings.rst.common.Seating.SeatAssignmentOption",
                                        "id": 2,
                                        "rule": "optional",
                                        "options": {
                                          "default": "REQUIRED"
                                        }
                                      }
                                    },
                                    "nested": {
                                      "SeatAssignmentOption": {
                                        "values": {
                                          "DISABLED": 0,
                                          "OPTIONAL": 1,
                                          "REQUIRED": 2
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.rst?.nested?.common?.nested?.Seating && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.rst?.nested?.common?.nested?.Seating?.nested?.SeatAssignmentOption) {
  $root.addJSON(jsonData);
}

/**
 * IMPORTANT: When Adding New Fields to Device Profiles, you MUST implement their default values at:
 *
 * /java/device-settings/src/main/java/com/squareup/devicesettings/processing/profiles/v2/defaults
 *
 * ⚠️ WARNING: Fields will not be automatically hydrated unless default values are implemented in the Java code above.
 * This is a mandatory step for all device profile settings.
 *
 * SOURCE Seating @ squareup/devicesettings/profiles/v2/model/settings/rst/common/seating.proto at 17:1
 */
export const Seating = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.rst.common.Seating');
fixType(Seating);
Builder.createAndAttachToType(Seating);
/**
 * SOURCE SeatAssignmentOption @ squareup/devicesettings/profiles/v2/model/settings/rst/common/seating.proto at 20:3
 */
Seating.SeatAssignmentOption = $root.lookupEnum('squareup.devicesettings.profiles.v2.model.settings.rst.common.Seating.SeatAssignmentOption').values;